<template>
<div class="authAddrDialog" v-if="dialogVisible">
    <el-dialog title="审核提货点" :visible.sync="dialogVisible" width="600px" center @close='cancel'>
        <div class="result-list btn-operate-list">
            <div class="mapaddress">
                <div class="mapaddress-box">
                    <div class="mapaddress-innerbox">提货点：{{item.name}}</div>
                    <div class="mapaddress-innerbox">提货点联系人：{{item.linkman}}</div>
                </div>
                <div class="mapaddress-box">
                    <div class="mapaddress-innerbox">地址：{{item.address}}</div>
                    <div class="mapaddress-innerbox">提货点电话：{{item.linktel}}</div>
                </div>
            </div>
        </div>
        <div class="title">
            <div class="box">
                <span class="innerbox"><img :src="item.objrolelogo " alt="" class="img"><span>{{item.objrolename}} </span></span>
                <span class="innerbox">申请时间：{{item.datetime}}</span>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="reject">不通过</el-button>
            <el-button type="primary" @click="pass">通过</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {uploadPickupPointInfoAuditInfo, getPickupPointInfoByHost} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'authAddrDialog',
    data() {
        return {
            dialogVisible: false,
            item: {
                ppinnerid: ''
            }
        }
    },
    mounted() {
    },
    methods: {
        openDialog(obj) {
            this.dialogVisible = true
            this.item.ppinnerid = obj.ppinnerid
            this._getView()
        },
        cancel() {
            this.dialogVisible = false
        },
        reject() {
            this.$confirm('确认驳回提货点申请', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                let obj = {
                    ppinnerid: this.item.ppinnerid,
                    status: 0
                }
                this._save(obj)
            })
        },
        pass() {
            this.$confirm('确认通过提货点申请', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                let obj = {
                    ppinnerid: this.item.ppinnerid,
                    status: 1
                }
                this._save(obj)
            })
        },
        _save(obj) {
            this.setLoading(true)
            uploadPickupPointInfoAuditInfo({
                data: Object.assign({}, obj),
                success: data => {
                    this.$message.success('审核成功')
                    this.$emit('getList')
                    this.cancel()
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getView() {
            this.setLoading(true)
            getPickupPointInfoByHost({
                data: Object.assign({}, {ppinnerid: this.item.ppinnerid}),
                success: data => {
                    this.item = data.data
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['page', 'brandBusiness', 'user', 'params',])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.authAddrDialog {
    .title {
        font-size: 14px;
        margin-top: 20px;
        padding-top: 20px;
        border-top: 1px solid #DCDFE6;
        .box {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .img {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin: 0 10px;
            }
            .innerbox {
                display: flex;
                align-items: center;
                width: 50%;
            }
        }
    }
    .mapaddress {
        display: flex;
        padding: 10px 20px;
        box-sizing: border-box;
        .mapaddress-box {
            width: 50%;
            .mapaddress-innerbox + .mapaddress-innerbox {
                margin-top: 20px;
            }
        }
    }
}
</style>
